import React from 'react';
import Bg from '../../../Assets/Backgrounds/appDesktopBanner.webp';

import AppsBanner from '../../Shared/AppsBanner/AppsBanner';
 import {ReactComponent as Btn1} from '../../../Assets/Icons/desktop1.svg';
 import {ReactComponent as Btn2} from '../../../Assets/Icons/desktop2.svg';

const Banner=()=>{
    return(
        <>
        <AppsBanner 
        title="Never present static designs again, prototypes communicate ideas better"
        backgroundImage={Bg}
        btn1={<Btn1 />}
        btn2={<Btn2 />}

        />
        
        </>
    )
};
export default Banner ;